import { Component, OnInit } from '@angular/core';
import { CollectionsService } from '../../service/collections.service';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
import i18next from 'i18next';
import { CollectionInterface } from '../../interfaces/collection.interface';
import { Store } from '@ngrx/store';
import { CollectionsFilterInterface } from '../../interfaces/collections-filter.interface';
import { ToastrService } from 'ngx-toastr';
import { CartService } from '../../../cart/services/cart.service';
import { NativeIntegrationService } from '../../../../core/services/native-integration.service';
import { Router } from '@angular/router';
import { BatchProductInterface } from 'src/modules/cart/interfaces/cart.interface';
import { BridgeMode } from '@hg-com/xwc-js-bridge';

@Component({
  selector: 'app-collections',
  templateUrl: './collections.component.html',
  styleUrls: ['./collections.component.scss'],
})
export class CollectionsComponent implements OnInit {
  collectionData: CollectionInterface[] | undefined;
  collectionsLength: number | undefined;
  dataLoaded = this.collectionsService.dataLoaded;
  private subscriptions: Subscription = new Subscription();

  constructor(
    public collectionsService: CollectionsService,
    private store: Store<{ collectionsFilter: CollectionsFilterInterface }>,
    private toastr: ToastrService,
    private cartService: CartService,
    private nis: NativeIntegrationService,
    private router: Router,
    private nativeService: NativeIntegrationService
  ) {
    this.collectionsService.loadDataSub
      .pipe(
        take(1),
        map((item: any) => {
          this.serveData();
        })
      )
      .subscribe();
  }

  ngOnInit(): void {
    if (this.dataLoaded) {
      this.serveData();
    }
  }

  serveData(): void {
    this.collectionData = Object.values(
      this.collectionsService.collectionsData
    ).sort((a, b) =>
      i18next.t(a.texts.title).localeCompare(i18next.t(b.texts.title))
    );

    this.collectionsLength = Object.keys(
      this.collectionsService.collectionsData
    ).length;

    const filterSub = this.store
      .select('collectionsFilter')
      .subscribe((data) => {
        this.collectionData = Object.values(
          this.collectionsService.collectionsData
        );

        if (
          data.tags.alphabet.letter &&
          data.tags.alphabet.letter !== '' &&
          this.collectionData
        ) {
          this.collectionData = Object.values(
            this.collectionsService.collectionsData
          );
          this.collectionData = this.collectionData.filter((collection) => {
            return i18next
              .t(collection.texts.title)
              .startsWith(data.tags.alphabet.letter);
          });
        }

        if (
          data.activeFilterCollection.categories.length > 0 &&
          this.collectionData
        ) {
          this.collectionData = this.collectionData.filter((collection) => {
            if (collection.filters._default) {
              return collection.filters._default.category_type.some(
                (category: number) => {
                  return data.activeFilterCollection.categories.includes(
                    category.toString()
                  );
                }
              );
            } else {
              console.log(
                'Missing category type: ' +
                  collection.id +
                  ' ' +
                  i18next.t(collection.texts.title)
              );
            }
          });
        }

        if (this.collectionData) {
          this.collectionsLength = Object.keys(this.collectionData).length;
          this.collectionData = this.collectionData.sort((a, b) =>
            i18next.t(a.texts.title).localeCompare(i18next.t(b.texts.title))
          );
          // console.log(this.collectionData);
          // console.log(data.activeFilterCollection.categories);
        }
      });
    this.subscriptions.add(filterSub);
  }

  ngOnDestroy(): void {
    // his.store.dispatch(SelectLetter({letter: ''}));
    // this.store.dispatch(ResetCollectionsFilters());
    this.subscriptions.unsubscribe();
  }

  // tslint:disable-next-line:typedef
  addAllToBag(): Observable<any> {
    return new Observable<any>((subscriber) => {
      const data: BatchProductInterface[] = [];
      for (let i = 0; i < this.collectionData!.length; i++) {
        const collection = this.collectionData![i];
        const products = this.collectionsService.getProductsDataFromCollection(
          collection.id.toString()
        );
        for (let j = 0; j < products.length; j++) {
          const product = products[j];
          data.push({
            product,
            collectionId: collection.id.toString(),
            quantity: 1,
          });
        }
      }
      this.cartService.batchAddToCart(data);
      subscriber.complete();
    });
  }

  openCart(): void {
    this.cartService.cartOpen$.next(true);
    this.nis.hapticFeedbackClick();
  }

  addAllToBagPressed(): void {
    console.log('addition is starting...');
    const addAllToBagSub = this.addAllToBag().subscribe({
      complete: () => {
        console.log('addition is done');
        const toastAddSub = this.toastr
          .info(i18next.t('add-to-cart.add-all-products'))
          .onTap.pipe(take(1))
          .subscribe(() => this.openCart());
        this.subscriptions.add(toastAddSub);
      },
    });
    this.subscriptions.add(addAllToBagSub);
  }

  addToCart(e: Event, collection: CollectionInterface) {
    e.stopPropagation();
    const addCollectionToBagSub = new Observable<any>((subscriber) => {
      const products = this.collectionsService.getProductsDataFromCollection(
        collection.id.toString()
      );
      const data: BatchProductInterface[] = [];
      for (let i = 0; i < products.length; i++) {
        data.push({
          product: products[i],
          collectionId: collection.id.toString(),
          quantity: 1,
        });
      }
      this.cartService.batchAddToCart(data);
      subscriber.complete();
    }).subscribe({
      complete: () => {
        console.log('addition is done');
        const toastAddSub = this.toastr
          .info(i18next.t('add-to-cart.add-all-products'))
          .onTap.pipe(take(1))
          .subscribe(() => this.openCart());
        this.subscriptions.add(toastAddSub);
      },
    });
    this.subscriptions.add(addCollectionToBagSub);
  }

  openCollection(e: Event, collection: CollectionInterface) {
    // @ts-ignore
    if (e.currentTarget!.tagName.toLowerCase() !== 'button') {
      this.router.navigate(['collections', 'collection-detail', collection.id]);
    }
  }

  public isNative() {
    return this.nativeService.native.mode > BridgeMode.Mock;
  }
}
